import {
  useSuspenseQuery,
  type UseSuspenseQueryOptions,
} from "@tanstack/react-query";
import { useExonnApi } from "src/exonn-api/exonn-api.tsx";
import type {
  CountryResource,
  CurrencyResource,
  LanguageResource,
} from "@exonn/js-sdk";

export type GlobalSettings = {
  default_country: CountryResource;
  default_language: LanguageResource;
  default_currency: CurrencyResource;
  prices_defined_in_net: boolean;
  prices_show_in_net: boolean;
  use_commission_supplier_orders: boolean;
  delivery_methods_that_require_tax_calculation: string[];
  countries_vat_status: string[];
  marketing_sms_texts_amount: number;
  marketing_allow_downloading_customers_list: boolean;
  accounting_postings_blocked_date: string;
};

type ResponseData = {
  data: GlobalSettings;
};

export const useGlobalSettings = (
  options?: Omit<
    UseSuspenseQueryOptions<
      ResponseData["data"],
      any,
      ResponseData["data"],
      any
    >,
    "queryFn" | "queryKey"
  >,
) => {
  const api = useExonnApi();
  return useSuspenseQuery({
    queryKey: ["globalSettings"],
    queryFn: async ({ signal }) => {
      return (
        await api.client.get<ResponseData>("/system/global-settings/all", {
          signal,
        })
      ).data.data;
    },
    ...options,
  });
};
